import React from 'react';
import { Card } from 'react-bootstrap';
import { notificationType } from '../../constants/globals';
import Alert from '../Reusable/Alert';

const AlertDemo = () => {
  return (
    <Card className={`table-card-style`}>
      <Card.Header className="table-card-header-style">
        <Card.Title className="d-flex gap-3 align-items-center">
          Info box
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Alert
          title="Error"
          severity={notificationType.error}
          message={'This is an error alert — check it out'}
        />
        <Alert
          title="Warning"
          severity={notificationType.warning}
          message={'This is an warning alert — check it out'}
        />
        <Alert
          severity={notificationType.info}
          message={'This is an info alert — check it out'}
        />
        <Alert
          severity={notificationType.success}
          message={'This is an success alert — check it out'}
        />
      </Card.Body>
    </Card>
  );
};

export default AlertDemo;
